// extracted by mini-css-extract-plugin
export var actionButton = "_8a-0";
export var attachmentLine = "_8a-1";
export var fileInput = "_8a-2";
export var fileUploadWrapper = "_8a-4";
export var footer = "_8a-3";
export var modalContent = "_8a-5";
export var paperclip = "_8a-6";
export var quillEditor = "_8a-7";